import {
  WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID,
  WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID,
  WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE,
  WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS,
  WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW,
  WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET,
  WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE,
} from '../action-types';
import { showErrorMessage } from '../../../messages';
import { addOpenItem } from './details';
import { tasksApi } from '../../../../services/api/tasks-api';

export function changeAssigneeRequest(taskId) {
  return (dispatch) => {
    return tasksApi.getMembers(taskId).then((response) => {
      if (response.ok) {
        dispatch(loadUsersSuccess(response.members));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function invalidForm(invalidFields, message) {
  return {
    type: WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_INVALID,
    payload: { invalidFields, message },
  };
}

export function setEditOpenItem(value) {
  return {
    type: WORK_ORDERS_DETAILS_OPEN_ITEM_EDIT_SET,
    payload: value,
  };
}

export function loadUsersSuccess(users) {
  return {
    type: WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MEMBERS_LOAD_SUCCESS,
    payload: users,
  };
}

export function setShowAddOpenItemModal(open) {
  return {
    type: WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_MODAL_SHOW,
    payload: open,
  };
}

export function setShowAddOpenItemModalRequest(taskId) {
  return (dispatch) => {
    return tasksApi.getMembers(taskId).then((response) => {
      if (response.ok) {
        dispatch(loadUsersSuccess(response.members));
        dispatch(setShowAddOpenItemModal(true));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function submitFormRequest(taskId, form) {
  return (dispatch) => {
    // Validate form
    const requiredFields = ['memberId', 'description', 'dueDate'];
    const invalidFields = [];
    requiredFields.forEach((attribute) => {
      if (form[attribute] === '' || form[attribute] === null) {
        invalidFields.push(attribute);
      }
    });

    if (invalidFields.length > 0) {
      dispatch(
        invalidForm(
          invalidFields,
          'The outlined inputs should be added in order to add an open item.'
        )
      );
    } else {
      dispatch(validForm());
      return tasksApi
        .addOpenItem(
          taskId,
          form.memberId,
          form.description,
          form.critical,
          form.dueDate
        )
        .then((response) => {
          if (response.ok) {
            dispatch(addOpenItem(response.openItem));
            dispatch(setShowAddOpenItemModal(false));
          } else {
            dispatch(showErrorMessage(response.errors));
          }
        });
    }
  };
}

export function updateFormValue(attribute, value) {
  return {
    type: WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALUE_UPDATE,
    payload: { attribute, value },
  };
}

export function updateEditFormValue(attribute, value) {
  return {
    type: WORK_ORDERS_DETAILS_EDIT_OPEN_ITEM_FORM_VALUE_UPDATE,
    payload: { attribute, value },
  };
}

export function validForm() {
  return {
    type: WORK_ORDERS_DETAILS_ADD_OPEN_ITEM_FORM_VALID,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/open-items.js